/** Plain-text search for organization settings lists; each word must match some visible field. */
export function matchesSettingsSearch(fields: readonly (string | null | undefined)[], query: string): boolean {
  const haystack = fields
    .filter((field): field is string => field !== null && field !== undefined)
    .join(' ')
    .toLocaleLowerCase();
  return query
    .toLocaleLowerCase()
    .trim()
    .split(/\s+/)
    .every((word) => haystack.includes(word));
}
